import { render, staticRenderFns } from "./averages.vue?vue&type=template&id=8ac36dfe&scoped=true"
import script from "./averages.vue?vue&type=script&lang=js"
export * from "./averages.vue?vue&type=script&lang=js"
import style0 from "./averages.vue?vue&type=style&index=0&id=8ac36dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac36dfe",
  null
  
)

export default component.exports